"use client";

import { QuestionMarkCircledIcon } from "@radix-ui/react-icons";
import { Text } from "@radix-ui/themes";
import Link from "next/link";
import { HybridTooltip, HybridTooltipTrigger, HybridTooltipContent, TouchProvider } from "@/app/components/ui/hybrid-tooltip";

const DoubleBidTooltip = () => {
    return (
        <TouchProvider>
            <HybridTooltip>
                <HybridTooltipTrigger>
                    <span>
                        <QuestionMarkCircledIcon />
                    </span>
                </HybridTooltipTrigger>
                <HybridTooltipContent>
                    <Text>Why are there duplicate bids on this lot? <Link href='/bidding-info' className="text-blue-300">Learn more</Link>.</Text>
                </HybridTooltipContent>
            </HybridTooltip>
        </TouchProvider>
    )
}

export default DoubleBidTooltip;